import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography
} from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'

import Show from '../../Layout/Can/Show'
import DynamicForm from '../../Shared/Forms/DynamicForm'
import { useDevices } from '../Contexts/DevicesContext'

const ConfigureDownlink = ({
  device,
  onChange = () => { },
  downlinkPayload
}) => {
  const { useSearchDownlinks } = useDevices()

  const [savePreset, setSavePreset] = useState(false)
  const [fieldsPayload, setFieldsPayload] = useState({})
  const [downlink, setDownlink] = useState('')
  const [downlinks, setDownlinks] = useState()
  const [isDownlinksLoading, setIsDownlinksLoading] = useState(false)

  const handleDownlinksChange = (event) => {
    const selectedDownlink = event.target.value
    const defaultFieldsPayload = selectedDownlink.fields
      .map((f) => f.internalName)
      .reduce((acc, internalName) => ({
        ...acc,
        [internalName]: ''
      }), {})

    setFieldsPayload(defaultFieldsPayload)
    setDownlink(selectedDownlink)

    onChange({
      ...downlinkPayload,
      downlink: selectedDownlink,
      defaultFieldsPayload
    })
  }

  const handleNameChange = (event) => {
    onChange({
      ...downlinkPayload,
      name: event.target.value
    })
  }

  const handleSavePreset = (event) => {
    const {
      target: { checked }
    } = event

    setSavePreset(checked)
    onChange({
      ...downlinkPayload,
      savePreset: checked
    })
  }

  const handleDynamicFormChange = (value, isValid) => {
    setFieldsPayload(value)
    onChange({
      ...downlinkPayload,
      fieldsPayload: value,
      isValid: isValid
    })
  }

  useEffect(() => {
    setIsDownlinksLoading(true)

    useSearchDownlinks({
      brand: device?.brandEncoded,
      model: device?.modelEncoded
    })
      .then((res) => {
        setDownlinks(res.data)
      })
      .finally(() => {
        setIsDownlinksLoading(false)
      })
  }, [])

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        display="flex"
        alignItems="center"
      >
        <Grid size={6}>
          <FormControlLabel
            control={<Switch onClick={handleSavePreset} />}
            label={t('actions.savePreset')}
          />
        </Grid>

        <Grid size={6}>
          <TextField
            variant="standard"
            label={t('common.name')}
            fullWidth
            onChange={handleNameChange}
            disabled={!savePreset}
          />
        </Grid>
      </Grid>

      <Typography
        variant="h5"
        align="center"
        my={5}
      >
        {t('actions.parameters')}
      </Typography>

      <Grid
        container
        spacing={2}
      >
        <Grid size={12}>
          <FormControl fullWidth>
            <InputLabel id="downlink-select-label">
              {t('actions.downlink')}
            </InputLabel>
            <Select
              labelId="downlink-select-label"
              id="downlink-select"
              value={downlink}
              label={t('actions.downlink')}
              inputProps={{
                id: 'downlink-select',
                'aria-labelledby': 'downlink-select-label downlink-select'
              }}
              onChange={handleDownlinksChange}
            >
              {!isDownlinksLoading &&
                downlinks?.map((downlink, i) => (
                  <MenuItem
                    key={`downlink-${i}`}
                    value={downlink}
                  >
                    {downlink.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid
          display="flex"
          justifyContent="flex-start"
        >
          <Show when={() => downlinkPayload.downlink?.downlinkAckByUplink}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled
                  value={downlinkPayload.downlink?.downlinkAckByUplink}
                />
              }
              label={t('actions.sendUplink')}
            />
          </Show>
        </Grid>
        <Grid
          item
          width={'100%'}
        >
          {downlink && (
            <DynamicForm
              fieldsPayload={fieldsPayload}
              fields={downlink.fields}
              onChange={handleDynamicFormChange}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ConfigureDownlink
